import React ,{Fragment} from 'react'
import classes from './model.module.css'
import  ReactDOM  from 'react-dom';

const Backdrop =  props => {
    return <div className={classes.backdrop}  onClick={props.onClose}>
    </div>
};
const ModalOverlay =  props => {
    return <div className={classes.modal}>
        <div className={classes.content}> 
        {props.children}

        </div>
    </div>
    
};


const porttalElement = document.getElementById('overlays')

export default function Modal(props) {
  return (
    <Fragment>
    {ReactDOM.createPortal(<Backdrop onClose={props.onClose}/> , porttalElement)}
    {ReactDOM.createPortal(<ModalOverlay>{props.children}</ModalOverlay>,porttalElement)}
    


    </Fragment>

  )
}
